export enum BookingStateEnum {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  OPEN = 'OPEN',
  CHECKEDIN = 'CHECKEDIN',
  CHECKEDOUT = 'CHECKEDOUT',
  CANCELED = 'CANCELED',
  ABSENCE = 'ABSENCE',
  HOLIDAY = 'HOLIDAY',
  EVENT = 'EVENT',
  DELETED = 'DELETED',
}

export type BookingState = keyof typeof BookingStateEnum

export function isBookableState(state: BookingState): boolean {
  return (
    state === BookingStateEnum.ACCEPTED ||
    state === BookingStateEnum.OPEN ||
    state === BookingStateEnum.CHECKEDIN
  )
}
